import { LIBRARY } from '../../const';

export let getPrimaryMetadataName = metadatas => {
  if (metadatas && metadatas.length) {
    for (let i = 0; i < metadatas.length; i++) {
      if (metadatas[i] && metadatas[i].metadataFilterType === LIBRARY.FILTER_TYPE.PRIMARY_FILTER) {
        return metadatas[i].metadataValue;
      }
    }
  }
  return '';
};
